"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _LS2SNHDMcjs = require('../__chunks/LS2SNHDM.cjs');


var _75F3RDBEcjs = require('../__chunks/75F3RDBE.cjs');


var _UGAVMSQJcjs = require('../__chunks/UGAVMSQJ.cjs');
require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/CVLMIMPT.cjs');
require('../__chunks/2RUCRSRF.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');








var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');



var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/combobox/combobox-store.ts
var isTouchSafari = _LS2SNHDMcjs.isSafari.call(void 0, ) && _LS2SNHDMcjs.isTouchDevice.call(void 0, );
function createComboboxStore({
  tag,
  ...props
} = {}) {
  const store = _WMTGHDLEcjs.mergeStore.call(void 0, props.store, _WMTGHDLEcjs.pick.call(void 0, tag, ["value", "rtl"]));
  _WMTGHDLEcjs.throwOnConflictingProps.call(void 0, props, store);
  const tagState = tag == null ? void 0 : tag.getState();
  const syncState = store == null ? void 0 : store.getState();
  const activeId = _4TRESXTOcjs.defaultValue.call(void 0, 
    props.activeId,
    syncState == null ? void 0 : syncState.activeId,
    props.defaultActiveId,
    null
  );
  const composite = _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    activeId,
    includesBaseElement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      true
    ),
    orientation: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "vertical"
    ),
    focusLoop: _4TRESXTOcjs.defaultValue.call(void 0, props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true),
    focusWrap: _4TRESXTOcjs.defaultValue.call(void 0, props.focusWrap, syncState == null ? void 0 : syncState.focusWrap, true),
    virtualFocus: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.virtualFocus,
      syncState == null ? void 0 : syncState.virtualFocus,
      true
    )
  });
  const popover = _75F3RDBEcjs.createPopoverStore.call(void 0, {
    ...props,
    placement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.placement,
      syncState == null ? void 0 : syncState.placement,
      "bottom-start"
    )
  });
  const value = _4TRESXTOcjs.defaultValue.call(void 0, 
    props.value,
    syncState == null ? void 0 : syncState.value,
    props.defaultValue,
    ""
  );
  const selectedValue = _4TRESXTOcjs.defaultValue.call(void 0, 
    props.selectedValue,
    syncState == null ? void 0 : syncState.selectedValue,
    tagState == null ? void 0 : tagState.values,
    props.defaultSelectedValue,
    ""
  );
  const multiSelectable = Array.isArray(selectedValue);
  const initialState = {
    ...composite.getState(),
    ...popover.getState(),
    value,
    selectedValue,
    resetValueOnSelect: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.resetValueOnSelect,
      syncState == null ? void 0 : syncState.resetValueOnSelect,
      multiSelectable
    ),
    resetValueOnHide: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.resetValueOnHide,
      syncState == null ? void 0 : syncState.resetValueOnHide,
      multiSelectable && !tag
    ),
    activeValue: syncState == null ? void 0 : syncState.activeValue
  };
  const combobox = _WMTGHDLEcjs.createStore.call(void 0, initialState, composite, popover, store);
  if (isTouchSafari) {
    _WMTGHDLEcjs.setup.call(void 0, 
      combobox,
      () => _WMTGHDLEcjs.sync.call(void 0, combobox, ["virtualFocus"], () => {
        combobox.setState("virtualFocus", false);
      })
    );
  }
  _WMTGHDLEcjs.setup.call(void 0, combobox, () => {
    if (!tag) return;
    return _4TRESXTOcjs.chain.call(void 0, 
      _WMTGHDLEcjs.sync.call(void 0, combobox, ["selectedValue"], (state) => {
        if (!Array.isArray(state.selectedValue)) return;
        tag.setValues(state.selectedValue);
      }),
      _WMTGHDLEcjs.sync.call(void 0, tag, ["values"], (state) => {
        combobox.setState("selectedValue", state.values);
      })
    );
  });
  _WMTGHDLEcjs.setup.call(void 0, 
    combobox,
    () => _WMTGHDLEcjs.sync.call(void 0, combobox, ["resetValueOnHide", "mounted"], (state) => {
      if (!state.resetValueOnHide) return;
      if (state.mounted) return;
      combobox.setState("value", value);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    combobox,
    () => _WMTGHDLEcjs.sync.call(void 0, combobox, ["open"], (state) => {
      if (state.open) return;
      combobox.setState("activeId", activeId);
      combobox.setState("moves", 0);
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    combobox,
    () => _WMTGHDLEcjs.sync.call(void 0, combobox, ["moves", "activeId"], (state, prevState) => {
      if (state.moves === prevState.moves) {
        combobox.setState("activeValue", void 0);
      }
    })
  );
  _WMTGHDLEcjs.setup.call(void 0, 
    combobox,
    () => _WMTGHDLEcjs.batch.call(void 0, combobox, ["moves", "renderedItems"], (state, prev) => {
      if (state.moves === prev.moves) return;
      const { activeId: activeId2 } = combobox.getState();
      const activeItem = composite.item(activeId2);
      combobox.setState("activeValue", activeItem == null ? void 0 : activeItem.value);
    })
  );
  return {
    ...popover,
    ...composite,
    ...combobox,
    tag,
    setValue: (value2) => combobox.setState("value", value2),
    resetValue: () => combobox.setState("value", initialState.value),
    setSelectedValue: (selectedValue2) => combobox.setState("selectedValue", selectedValue2)
  };
}


exports.createComboboxStore = createComboboxStore;
